export const AppRoutesConstant = {
  BookedOrder: '/booked-order',
  CommonOrder: '/order',
  Overview: '/overview',
  SplitPnr: '/split-pnr',
};
